module.exports = __webpack_public_path__ + "files/deb7c3e60fbabd81678a7b77c779ef51.png";